"use strict";

exports.__esModule = true;
exports.default = Error404;

var _utils = require("./utils");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Error404(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "135.321",
    height: "87"
  }, (0, _utils.getIllustrationProps)(props)), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.821 60.5v23a2.006 2.006 0 002 2h118a2.006 2.006 0 002-2v-80a2.006 2.006 0 00-2-2h-118a2.006 2.006 0 00-2 2v27",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    strokeWidth: "2",
    d: "M133.721 14h-122M29.721 8h-10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    strokeWidth: "3",
    d: "M2.121 55.1l19.3-19.2M21.421 55.1l-19.3-19.2"
  })));
}